import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    questions: [
      {
        question: "Please select your <span class='text-highlight'>gender</span>:",
        suggestions:[
          {suggestion:"Male", image: "male.jpg"},
          {suggestion:"Female", image: "female.jpg"}
        ]
      },
      {
        question: "What describes your <span class='text-highlight'>current situation</span>? <span class='underline'>I am</span>:",
        suggestions:[
          {suggestion:"Employee", image: "worker.jpg"},
          {suggestion:"Entrepreneur", image: "business.jpg"},
          {suggestion:"Freelancer", image: "freelancer.jpg"},
          {suggestion:"Student", image: "student.jpg"}
        ]
      },
      {
        question: "How much <span class='text-highlight'>experience</span> do you have with <span class='text-highlight'>online businesses</span>? <span class='underline'>My level is</span>:",
        suggestions:[
          {suggestion:"Beginner", image: "snake.jpg"},
          {suggestion:"Advanced", image: "turtle.jpg"},
          {suggestion:"Expert", image: "horse.jpg"},
          {suggestion:"Master", image: "cheetah.jpg"}
        ]
      },
      {
        question: "How much <span class='text-highlight'>money</span> would you like to earn per month?",
        suggestions:[
          {suggestion:"$100 - $1,000", image: "bicycle.jpg"},
          {suggestion:"$1,000 - $3,000", image: "motorcycle.jpg"},
          {suggestion:"$3,000 - $10,000", image: "supercar.jpg"},
          {suggestion:"$10,000 - $15,000", image: "yacht.jpg"}
        ]
      }
    ]
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
